import { useState } from "react";
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import Button from "../../ui/Button";
import { months, years, currentMonth, currentYear } from "../../utils/date.utils";

export default function MoneyReceiptExportModal({
  isOpen,
  toggle,
  onExport,
  isExporting = false,
  defaultCustomerId = "",
  defaultCaid = ""
}) {
  const [scope, setScope] = useState("all");
  const [month, setMonth] = useState(currentMonth());
  const [year, setYear] = useState(currentYear());

  const handleSubmit = () => {
    const params = {
      type_id: 2
    };

    if (defaultCustomerId) params.customer_id = defaultCustomerId;
    if (defaultCaid) params.caid = defaultCaid;

    if (scope === "all") {
      onExport(params, "all");
      return;
    }

    const lastDay = new Date(year, month, 0).getDate();
    const monthLabel = String(month).padStart(2, "0");

    params.start_date = `${year}-${monthLabel}-01`;
    params.end_date = `${year}-${monthLabel}-${String(lastDay).padStart(2, "0")}`;

    onExport(params, `${year}-${monthLabel}`);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Export Money Receipts</ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <label className="form-label fw-semibold" htmlFor="mr-export-scope">
            Export Scope
          </label>
          <select
            id="mr-export-scope"
            className="form-select"
            value={scope}
            onChange={(e) => setScope(e.target.value)}
            disabled={isExporting}
          >
            <option value="all">All Money Receipts</option>
            <option value="month">Month & Year</option>
          </select>
        </div>
        {scope === "month" && (
          <Row className="g-3">
            <Col xs={12} sm={6}>
              <label className="form-label fw-semibold" htmlFor="mr-export-month">
                Month
              </label>
              <select
                id="mr-export-month"
                className="form-select"
                value={month}
                onChange={(e) => setMonth(Number(e.target.value))}
                disabled={isExporting}
              >
                {months.map((m) => (
                  <option key={m.value} value={m.value}>
                    {m.label}
                  </option>
                ))}
              </select>
            </Col>
            <Col xs={12} sm={6}>
              <label className="form-label fw-semibold" htmlFor="mr-export-year">
                Year
              </label>
              <select
                id="mr-export-year"
                className="form-select"
                value={year}
                onChange={(e) => setYear(Number(e.target.value))}
                disabled={isExporting}
              >
                {years().map((y) => (
                  <option key={y.value} value={y.value}>
                    {y.label}
                  </option>
                ))}
              </select>
            </Col>
          </Row>
        )}
        <small className="text-muted d-block mt-3">
          {scope === "all"
            ? "Exports every money receipt as an Excel-compatible CSV for audit and reporting."
            : "Exports all money receipts for the selected month/year as an Excel-compatible CSV for audit and reporting."}
        </small>
      </ModalBody>
      <ModalFooter>
        <Button color="light" name="Cancel" onClick={toggle} disabled={isExporting} />
        <Button
          color="primary"
          name={isExporting ? "Exporting..." : "Export Excel"}
          onClick={handleSubmit}
          disabled={isExporting}
        />
      </ModalFooter>
    </Modal>
  );
}